import { useState, useEffect } from 'react';
import type { User } from '@/types';

interface Props {
  user: User;
  size?: number;
}

export function UserAvatar({ user, size = 32 }: Props) {
  const [imgError, setImgError] = useState(false);
  const initial = (user.name ?? user.email).charAt(0).toUpperCase();

  // Reset error state whenever the URL changes (e.g. after a fresh upload)
  useEffect(() => { setImgError(false); }, [user.avatarUrl]);

  if (user.avatarUrl && !imgError) {
    return (
      <img
        src={user.avatarUrl}
        alt={user.name ?? user.email}
        referrerPolicy="no-referrer"
        onError={() => setImgError(true)}
        style={{ width: size, height: size }}
        className="rounded-full object-cover shrink-0 ring-1 ring-border"
      />
    );
  }

  return (
    <div
      style={{ width: size, height: size }}
      className="rounded-full bg-accent/20 text-accent flex items-center justify-center shrink-0 font-medium select-none text-sm ring-1 ring-border"
    >
      {initial}
    </div>
  );
}
